import React from "react";
import { CLIENT_LOGOS } from "../../config/clientConfig";
import "./ClientLogo.css";

/**
 * Shared client identity treatment. The frame intentionally matches the
 * Command Center Sidebar so client logos remain visually consistent wherever
 * they are used in the Control Tower.
 */
export default function ClientLogo({
  client,
  src,
  alt,
  active = false,
  activeColor,
  fallbackText,
  fallbackColor,
  title,
  className = "",
}) {
  const logo = src || (client ? CLIENT_LOGOS[client] : null);
  const label = alt || client || "Client logo";
  const resolvedFallbackText = fallbackText || client || "?";
  const frameClassName = [
    "client-logo-frame",
    active && "client-logo-frame--active",
    !logo && "client-logo-frame--fallback",
    className,
  ].filter(Boolean).join(" ");
  const frameStyle = activeColor ? { "--client-logo-accent": activeColor } : undefined;

  return (
    <span className={frameClassName} style={frameStyle} title={title}>
      {logo ? (
        <img src={logo} alt={label} className="client-logo-frame__image" />
      ) : (
        <span
          className="client-logo-frame__fallback"
          style={fallbackColor ? { "--client-logo-fallback-color": fallbackColor } : undefined}
        >
          {resolvedFallbackText}
        </span>
      )}
    </span>
  );
}
